import { AnnouncementStatus, AnnouncementType, type TSortKey } from '../types/announcement';

export const TYPES = [
  AnnouncementType.ANNOUNCEMENT_TYPE_UPDATE,
  AnnouncementType.ANNOUNCEMENT_TYPE_PROMO,
  AnnouncementType.ANNOUNCEMENT_TYPE_MAINTENANCE,
  AnnouncementType.ANNOUNCEMENT_TYPE_NEWS,
];

export const STATUSES = [
  AnnouncementStatus.ANNOUNCEMENT_STATUS_DRAFT,
  AnnouncementStatus.ANNOUNCEMENT_STATUS_SCHEDULED,
  AnnouncementStatus.ANNOUNCEMENT_STATUS_PUBLISHED,
  AnnouncementStatus.ANNOUNCEMENT_STATUS_WITHDRAWN,
  AnnouncementStatus.ANNOUNCEMENT_STATUS_EXPIRED,
];

/** Cannot change any more. */
export const FINAL_STATUSES = [
  AnnouncementStatus.ANNOUNCEMENT_STATUS_WITHDRAWN,
  AnnouncementStatus.ANNOUNCEMENT_STATUS_EXPIRED,
];
/** Can be withdrawn. */
export const LIVE_STATUSES = [
  AnnouncementStatus.ANNOUNCEMENT_STATUS_PUBLISHED,
  AnnouncementStatus.ANNOUNCEMENT_STATUS_SCHEDULED,
];

/** URL query values of the list filters (`?status=published&type=promo`); links already shared use them. */
export const STATUS_SLUGS: Partial<Record<AnnouncementStatus, string>> = {
  [AnnouncementStatus.ANNOUNCEMENT_STATUS_DRAFT]: 'draft',
  [AnnouncementStatus.ANNOUNCEMENT_STATUS_SCHEDULED]: 'scheduled',
  [AnnouncementStatus.ANNOUNCEMENT_STATUS_PUBLISHED]: 'published',
  [AnnouncementStatus.ANNOUNCEMENT_STATUS_WITHDRAWN]: 'withdrawn',
  [AnnouncementStatus.ANNOUNCEMENT_STATUS_EXPIRED]: 'expired',
};
export const TYPE_SLUGS: Partial<Record<AnnouncementType, string>> = {
  [AnnouncementType.ANNOUNCEMENT_TYPE_UPDATE]: 'update',
  [AnnouncementType.ANNOUNCEMENT_TYPE_PROMO]: 'promo',
  [AnnouncementType.ANNOUNCEMENT_TYPE_MAINTENANCE]: 'maintenance',
  [AnnouncementType.ANNOUNCEMENT_TYPE_NEWS]: 'news',
};

export const LANGUAGES = ['ru', 'en', 'zh'] as const;

export const PAGE_SIZES = [10, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = 20;
export const SORT_KEYS: TSortKey[] = ['status', 'type', 'title', 'updatedAt', 'version'];
